import { createSelector } from 'reselect';
import includes from 'lodash/includes';
import some from 'lodash/some';
import * as constants from './constants';
import * as actionTypes from './actionTypes';
import { groupNotificationsByTimestamp } from './helpers';
/**
 * Input selectors
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
const fetchingSelector = (state)=>state[constants.MODULE_ID].fetching;
const sendingSelector = (state)=>state[constants.MODULE_ID].sending;
const errorsSelector = (state)=>state[constants.MODULE_ID].errors;
//----------------------------------------------------------------------------------------------------------------------
export const notifications = (state)=>mainSelector(state).notifications;
/**
 * List of notifications
 */ export const notificationsRecords = (state)=>{
    var _notifications;
    return (_notifications = notifications(state)) === null || _notifications === void 0 ? void 0 : _notifications.records;
};
export const notificationsTotal = (state)=>{
    var _notifications;
    return (_notifications = notifications(state)) === null || _notifications === void 0 ? void 0 : _notifications.totalRecords;
};
export const notificationsTotalActive = (state)=>{
    var _notifications;
    return (_notifications = notifications(state)) === null || _notifications === void 0 ? void 0 : _notifications.totalActiveRecords;
};
export const notificationsRecordsGrouped = createSelector([
    notificationsRecords
], (notificationsRecordsState)=>groupNotificationsByTimestamp(notificationsRecordsState));
//----------------------------------------------------------------------------------------------------------------------
export const notificationsFilter = (state)=>mainSelector(state).notificationsFilter;
//----------------------------------------------------------------------------------------------------------------------
export const lastReceivedNotification = (state)=>mainSelector(state).lastReceivedNotification;
//----------------------------------------------------------------------------------------------------------------------
export const hasMoreNotificationsToLoad = (state)=>notificationsTotal(state) > notificationsFilter(state).limit;
export const hasAnyNotificationsToDismiss = createSelector([
    notificationsRecords
], (notificationsRecordsState)=>some(notificationsRecordsState, (notification)=>notification.status !== 'Dismissed'));
/**
 * List of notifications ids user is reading now. Only after reading it will be committed to notifications statuses.
 */ export const readNotificationsIds = (state)=>mainSelector(state).readNotificationsIds;
export const notificationsHistoryRecords = (state)=>{
    var _mainSelector_notificationsHistory;
    return (_mainSelector_notificationsHistory = mainSelector(state).notificationsHistory) === null || _mainSelector_notificationsHistory === void 0 ? void 0 : _mainSelector_notificationsHistory.records;
};
//----------------------------------------------------------------------------------------------------------------------
export const isFetchNotificationsInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.FETCH_LIST));
export const hasFetchNotificationsErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.FETCH_LIST));
//----------------------------------------------------------------------------------------------------------------------
export const isDismissFilteredNotificationsInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.DISMISS_FILTERED_NOTIFICATIONS));
export const hasDismissFilteredNotificationsErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.DISMISS_FILTERED_NOTIFICATIONS)); //----------------------------------------------------------------------------------------------------------------------
